import { render, staticRenderFns } from "./platform-items.vue?vue&type=template&id=3ea1b1b8"
import script from "./platform-items.vue?vue&type=script&lang=js"
export * from "./platform-items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports